import { TableCreatedSurveysComponent } from '../../components/table-created-surveys/table-created-surveys.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-created-surveys',
	templateUrl: './card-created-surveys.component.html',
	imports: [ CommonModule, TableCreatedSurveysComponent, ListPagerComponent, FormsModule ]
})
export class CardCreatedSurveysComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() questionnaireCode: any | undefined;

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.surveys = [];
		this.vm.pageSize = 10;
		this.vm.questionnaireCode = this.questionnaireCode;
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}